export default {
    name: "Air Freight",
    meta: {
        icon: "flight_takeoff",
        expanded: true,
        auth: true
    },
    departmentName: "Client",
    finalPagePermision: "",
    children: [{
        name: "Air-Import Details",
        path: "/Air/clientAirImport",
        meta: {
            icon: "flight_takeoff",
            auth: true
        },
        component: require("../component/clientDashboard/clientAirImportDetails.vue"),
        finalPagePermision: "",

    },
    {
        name: "Air-Export Details",
        path: "/AirImport/clientAirExport",
        meta: {
            icon: "flight_takeoff",
            auth: true
        },
        component: require("../component/clientDashboard/clientAirExport.vue"),
        finalPagePermision: "",

    },


    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/clientAirDash.js